import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { pct } from "./DueControl";

const STATUS_BADGE = { open: "bg-emerald-500/15 text-emerald-600", closed: "bg-muted text-muted-foreground" };

export function MatterList({ matters, activeId, onSelect, stageName }) {
  return (
    <div className="space-y-2 lg:max-h-[70vh] lg:overflow-y-auto pr-1" data-testid="matter-list">
      {matters.map((m) => (
        <button key={m.id} data-testid="matter-card" onClick={() => onSelect(m.id)}
          className={`w-full text-left border rounded-sm p-3.5 transition-colors ${activeId === m.id ? "border-primary bg-primary/5" : "border-border bg-card hover:border-primary/60"}`}>
          <div className="flex items-center justify-between gap-2">
            <span className="text-xs font-condensed font-semibold text-primary">{m.matter_number || "—"}</span>
            <span className={`text-[10px] px-1.5 py-0.5 rounded-sm uppercase font-semibold ${STATUS_BADGE[m.status] || ""}`}>{m.status}</span>
          </div>
          <div className="text-sm font-semibold mt-1 truncate">{m.client_name}</div>
          <div className="text-xs text-muted-foreground truncate">{m.title}</div>
          <div className="flex items-center gap-2 mt-2">
            <Badge variant="secondary" className="text-[10px]">{stageName(m.stage)}</Badge>
            <span className="text-[11px] text-muted-foreground ml-auto">{pct(m.checklist)}%</span>
          </div>
          <Progress value={pct(m.checklist)} className="h-1 mt-1.5" />
        </button>
      ))}
    </div>
  );
}
